import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import Swal from "sweetalert2";
import {
  LoadCanvasTemplate,
  loadCaptchaEnginge,
  validateCaptcha,
} from "react-simple-captcha";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import logo from "../../../images/logo.png";
import { firstLogin, verifyfirstLoginOTP } from "../../../environment";
import useApi from "../../../core/customhook/useApi";
type PasswordField = "password";

const FirstTimeLogin = () => {
  const routes = all_routes;
  const navigation = useNavigate();
  const [userCaptcha, setUserCaptcha] = useState("");

  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otp, setOtp] = useState("");

  const [timer, setTimer] = useState(120);

  const [authData, setAuthData] = useState({
    email: "",
    password: "",
  });

  const userLogin = useApi<any>(firstLogin, {
    method: "POST",
    autoCall: false,
    handleGlobalError: false,
  });

  const verifyLoginOTP = useApi<any>(verifyfirstLoginOTP, {
    method: "POST",
    autoCall: false,
    handleGlobalError: false,
  });

  useEffect(() => {
    loadCaptchaEnginge(6);
  }, []);

  useEffect(() => {
    let interval: any;

    if (showOtpModal && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [showOtpModal, timer]);

  const getInputData = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setAuthData({ ...authData, [name]: value });
  };

  const validateCaptchaInput = () => {
    if (!userCaptcha) {
      Swal.fire({
        icon: "warning",
        title: "Captcha Required",
        text: "Please enter captcha",
      });

      return false;
    }

    if (!validateCaptcha(userCaptcha)) {
      Swal.fire({
        icon: "error",
        title: "Invalid Captcha",
      });

      // setUserCaptcha("");
      loadCaptchaEnginge(6);

      return false;
    }

    return true;
  };

  const handleLogin = async () => {
    try {
      if (!authData.email) {
        Swal.fire({
          icon: "warning",
          title: "Email Required",
        });

        return;
      }

      if (!authData.password) {
        Swal.fire({
          icon: "warning",
          title: "Password Required",
        });

        return;
      }

      if (!validateCaptchaInput()) return;

      const payload = {
        email: authData.email,
        tempPassword: authData.password,
      };

      const response = await userLogin.callApi(payload);

      if (response?.success) {
        setShowOtpModal(true);
        setTimer(120);
        setOtp("");
      }
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Invalid credentials",
      });
    }
  };

  const handleOtpSubmit = async () => {
    try {
      if (!otp) {
        return;
      }

      const payload = {
        email: authData.email,
        otp: otp,
      };

      const response = await verifyLoginOTP.callApi(payload);
      if (response?.success) {
        navigation(routes.resetPassword2);
      }
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Invalid OTP",
      });
    }
  };

  const handleResend = async () => {
    try {
      const payload = {
        email: authData.email,
        tempPassword: authData.password,
      };

      const response = await userLogin.callApi(payload);

      if (response?.success) {
        setTimer(120);

        Swal.fire({
          icon: "success",
          title: "OTP Resent Successfully",
        });
      }
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Failed To Resend OTP",
      });
    }
  };

  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
  });

  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const maskEmail = (email: string) => {
    if (!email) return "";

    const [name, domain] = email.split("@");

    const maskedName =
      name.length <= 2
        ? name[0] + "*"
        : name[0] + "*".repeat(name.length - 2) + name[name.length - 1];

    const [domainName, extension] = domain.split(".");

    const maskedDomain = domainName[0] + "*".repeat(domainName.length - 1);

    return `${maskedName}@${maskedDomain}.${extension}`;
  };
  return (
    <div className="container">
      <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100 mb-3">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 mt-4">
            <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap">
              <div className="col-md-5 mx-auto vh-100">
                <div className=" mx-auto mb-2 text-center">
                  <ImageWithBasePath
                    src={logo}
                    className="img-fluid"
                    alt="Logo"
                  />
                </div>
                <form>
                  <div className="login_form_main">
                    <div className="d-flex flex-column justify-content-between p-4 pb-0">
                      <div className="">
                        <div className="text-center mb-3">
                          <h2 className="mb-2">
                            Candidate Portal First Time Login
                          </h2>
                          <p className="mb-0">Instant Background Screening</p>
                        </div>
                        <div className="mb-3">
                          <label className="form-label">
                            Enter Username/Email
                          </label>
                          <div className="input-group">
                            <input
                              type="text"
                              value={authData.email}
                              className="form-control border-end-0"
                              name="email"
                              onChange={getInputData}
                            />
                            <span className="input-group-text border-start-0">
                              <i className="ti ti-mail" />
                            </span>
                          </div>
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Enter Password</label>
                          <div className="pass-group">
                            <input
                              type={
                                passwordVisibility.password
                                  ? "text"
                                  : "password"
                              }
                              className="pass-input form-control"
                              name="password"
                              onChange={getInputData}
                            />
                            <span
                              className={`ti toggle-passwords ${
                                passwordVisibility.password
                                  ? "ti-eye"
                                  : "ti-eye-off"
                              }`}
                              onClick={() =>
                                togglePasswordVisibility("password")
                              }
                            ></span>
                          </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mb-3">
                          <div className="d-flex align-items-center">
                            <div className="form-check form-check-md mb-0">
                              <input
                                className="form-check-input"
                                id="remember_me"
                                type="checkbox"
                              />
                              <label
                                htmlFor="remember_me"
                                className="form-check-label mt-0"
                              >
                                Remember Me
                              </label>
                            </div>
                          </div>
                          <div className="text-end">
                            <Link
                              to={all_routes.forgotPassword}
                              className="link-danger"
                            >
                              Forgot Password?
                            </Link>
                          </div>
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Enter Captcha</label>

                          <div className="d-flex align-items-center gap-2 mb-2">
                            <div
                              style={{
                                border: "1px solid #ddd",
                                padding: "10px",
                                borderRadius: "5px",
                                width: "100%",
                                textAlign: "center",
                              }}
                            >
                              <LoadCanvasTemplate />
                            </div>

                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={() => {
                                loadCaptchaEnginge(6);
                                setUserCaptcha("");
                              }}
                            >
                              Refresh
                            </button>
                          </div>

                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Captcha"
                            value={userCaptcha}
                            onChange={(e) => setUserCaptcha(e.target.value)}
                          />
                        </div>
                        <div className="mb-3">
                          <button
                            type="button"
                            className="btn btn-primary w-100"
                            onClick={handleLogin}
                          >
                            Log In
                          </button>
                        </div>
                        <div className="login_footer">
                          <p>
                            This site is Complaint to{" "}
                            <Link to={"#"}>India Privacy Policy</Link> |{" "}
                            <Link to={"#"}>EU</Link> |{" "}
                            <Link to={"#"}>GDPR Privacy Policy</Link> |{" "}
                            <Link to={"#"}>Cookie Policy</Link>{" "}
                          </p>
                          <p className="mb-2">
                            For client login please visit{" "}
                            <Link style={{ color: "blue" }} to={"#"}>
                              candidatesupport@aupertz.co.in
                            </Link>{" "}
                            <span className="text-danger">
                              Candidate Resources
                            </span>{" "}
                            <Link style={{ color: "blue" }} to={"#"}>
                              Click here
                            </Link>{" "}
                          </p>
                          <p>
                            <span className="text-danger">
                              In case you are facing any issue please write to
                              us at{" "}
                            </span>{" "}
                            <Link
                              style={{ color: "blue" }}
                              to={"mailto:candidatesupport@aupertz.co.in"}
                            >
                              candidatesupport@aupertz.co.in
                            </Link>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showOtpModal && (
        <div className="custom-otp-modal-overlay">
          <div className="custom-otp-modal-dialog">
            <div className="custom-otp-modal-content">
              {/* CLOSE BUTTON */}
              <button
                className="custom-otp-close-btn"
                onClick={() => setShowOtpModal(false)}
              >
                ✕
              </button>
              {/* TITLE */}
              <h4 className="custom-otp-title">OTP AUTHENTICATION</h4>
              {/* MESSAGE */}
              <p className="custom-otp-message">
                You will receive 6 digit OTP on your registered Email{" "}
                <strong>{maskEmail(authData.email)}</strong> or Mobile{" "}
                {/* <strong>+91******10</strong> */}
              </p>
              {/* OTP SECTION */}
              <div className="custom-otp-input-row">
                <label className="custom-otp-label">Enter OTP</label>

                <input
                  type="text"
                  className="custom-otp-input"
                  placeholder=""
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                />

                <button
                  className="custom-otp-submit-btn"
                  onClick={handleOtpSubmit}
                >
                  Submit
                </button>
              </div>
              {!otp && (
                <p className="text-danger text-center">Please Enter OTP</p>
              )}
              {/* TIMER + RESEND */}
              <div className="custom-otp-bottom-row">
                <p className="custom-otp-timer">
                  OTP expires in {timer} seconds
                </p>

                <button
                  className="custom-otp-resend-btn"
                  disabled={timer > 0}
                  onClick={handleResend}
                >
                  Resend
                </button>
              </div>
              {/* FOOTER */}
              <p className="custom-otp-footer">
                In case you are facing any issues please write to us at{" "}
                <span>candidatesupport@aupertz.co.in</span>
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FirstTimeLogin;
